import Breadcrumb from "../components/Breadcrumb";
import SlotManagement from "../components/SlotManagement";

const SlotManagementPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Slot Management" />

      <SlotManagement />
    </>
  );
};

export default SlotManagementPage;
